import { useTranslation } from 'react-i18next';
import { StatusChip } from '@common/components/StatusChip';
import { Stack, SxProps } from '@mui/material';
import { Colors } from '../helpers/colors';

type Props = {
  status: string;
  isGroup: boolean;
  message?: string;
  sx?: SxProps;
};

export const Status = ({ status, isGroup, message, sx }: Props) => {
  const { t } = useTranslation('interface');

  return (
    <Stack sx={{ flexDirection: 'row', gap: '4px', ...sx }}>
      {isGroup && <StatusChip status={t(`simulation.run_card.group`)} color='info.main' />}
      <StatusChip
        status={t(`simulation.status_chip_2.status_${status}`)}
        color={Colors[status as keyof typeof Colors]}
        message={message}
      />
    </Stack>
  );
};
